














import Vue from 'vue'
import Login from '@/components/Login.vue'
import {
  ConferenceProfile,
  Configuration,
  PasswordResetInfoUserTypeEnum,
  PublicRestControllerApi,
} from '@/types/api-docs'
import NotFound from '@/components/NotFound.vue'
import Utils from '@/utils/utils'

const api = new PublicRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export interface DataType {
  profile?: ConferenceProfile
  userType: PasswordResetInfoUserTypeEnum
  notFound: boolean
}

export default Vue.extend({
  components: {
    NotFound,
    Login,
  },
  data(): DataType {
    return {
      profile: undefined,
      userType: PasswordResetInfoUserTypeEnum.Member,
      notFound: false,
    }
  },
  async mounted() {
    this.profile = await this.fetchConferenceProfile()
  },
  methods: {
    async fetchConferenceProfile() {
      const options = {
        query: Utils.getQueryParams(),
      }

      const { data } = await api
        .fetchConferenceProfile(options)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((data: any) => {
          return data
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err: any) => {
          const res = err.response
          const status = res === undefined ? undefined : res.status
          if (status === 404) {
            this.notFound = true
          }
          return undefined
        })
      return data
    },
  },
})
